import React, {useState} from 'react';
import Loading from './components/Loading';
import Main from './components/Main';
import NavBar from './components/NavBar/NavBar';
import SideBar from './components/NavBar/SideBarElements';
import './App.css';


function App() {
  // eslint-disable-next-line 
  const [isLoading,setIsLoading] = useState(false)
  const [isOpen,setIsOpen] = useState(false)

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  if(isLoading) {return ( <Loading /> )}


  return (
    <div className="App">
      <SideBar isOpen={isOpen} toggle={toggle}/>
      <NavBar toggle={toggle}/>
     <Main />
    </div>
  );
}

export default App;
